<template>
  <div class="sdg sdgg withdrawal">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('取款') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="tabVox">
      <div :class="activeName == 2 ? 'tab atc' : 'tab'" @click="changevT(2)">{{ $t('银行卡取款') }}</div>
      <div :class="activeName == 1 ? 'tab atc' : 'tab'" @click="changevT(1)">USDT{{$t('取款')}}</div>
    </div>
    <div class="content">
      <div class="card-info">
        <div class="qibao">
          <div class="fes">{{ $t('钱包金额') }}</div>
          <div class="imgs">
            <img @click="$parent.getUserInfoShowLoding()" src="/static/image/new/withdrawal/refresh-icon.png" alt="" /></div>
          <div class="btns" @click="transall">{{ $t('一键回收') }}</div>
        </div>
        <div class="mesg">
          <div class="bosgf">
            <div class="bots">
<!--              <span>VND</span>-->
              {{ $store.state.userInfo.balance }}</div>
            <div class="label"><img src="/static/image/new/withdrawal/money-icon1.png" alt="" />{{ $t('中心钱包') }}</div>
          </div>
          <div class="line"></div>
          <div class="bosgf">
            <div class="bots">
<!--              <span>VND</span>-->
              {{ gameblance || '0.00' }}</div>
            <div class="label"><img src="/static/image/new/withdrawal/money-icon2.png" alt="" />{{ $t('游戏钱包') }}</div>
          </div>
        </div>

        <div class="gameBox" v-if="balancelist.length" style="display: none;">
          <div class="lis" v-for="(item, index) in balancelist" v-if="index < showLis " :key="index">
            <div class="name">{{ item.name }}</div>
            <div class="num">{{ item.balance }}</div>
          </div>
          <div class="lis" v-if="showLis != 3" @click="changShowLis(3)">
            <div class="name">{{ $t('收起') }}</div>
            <div class="num"><img src="/static/image/xiangshang.png" alt="" /></div>
          </div>
          <div class="lis" v-if="showLis == 3" @click="changShowLis(balancelist.length )">
            <div class="name">{{ $t('展开') }}</div>
            <div class="num"><img src="/static/image/xiangxia.png" alt="" /></div>
          </div>
        </div>
      </div>
      <div class="usrse" v-if="activeName == 1">
        <div class="hgs" @click="$parent.goNav('/addUsdtCard')" v-if="usdssLis.length == 0">
          <div class="nams">{{ $t('选择USDT地址') }}</div>
          <div style="color: #4B5BF0; text-align: center;font-size: .32rem;">+ {{ $t('添加USDT地址') }}</div>
        </div>
        <div class="hgs" v-else @click="changShow">
          <div class="nams">{{ $t('选择USDT地址') }}</div>

          <div class="cardhgs" v-if="bankId">
            <img src="/static/image/1595237922936176.png" alt="" />
            <div>{{ hgInfo.bank_owner }} <span>****</span><span>****</span><span>****</span>{{ hgInfo.bank_no.substr(-4) }}</div>
          </div>
          <div v-else style="color: #1e90ff; height: 30px; line-height: 30px; text-align: center">{{ $t('请选择USDT地址') }}</div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('充值打码量') }}</div>
          <div>
            <van-cell-group>
              <van-field v-model="betAmount" type="text" disabled :placeholder="$t('打码量')"> </van-field>
            </van-cell-group>
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('赠送打码量') }}</div>
          <div>
            <van-cell-group>
              <van-field v-model="gift_water" type="text" disabled :placeholder="$t('打码量')"> </van-field>
            </van-cell-group>
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('取款金额') }}</div>
          <div>
            <van-cell-group>
              <van-field v-model="amount" type="text" :placeholder="$t('请输入取款金额')">
                <template #button>
                  <div class="all-money" @click="bigMey($store.state.userInfo.balance)">{{ $t('最大金额') }}</div>
                </template>
              </van-field>
            </van-cell-group>
          </div>
        </div>

        <div class="hgs">
          <div class="nams">{{ $t('支付密码') }}</div>
          <div>
            <van-cell-group>
              <van-field v-model="password" type="password"  autocomplete="new-password"  :placeholder="$t('请输入支付密码')"> </van-field>
            </van-cell-group>
          </div>
        </div>
        <div class="hgs" v-if="chanmeyXi">
          <div class="nams">{{ $t('每笔手续费') }}</div>
          <div>{{ chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee : $store.state.userInfo.withdrawfeeusdttrc }} USDT</div>
        </div>
        <div class="money-info-box">
          <div class="nams">{{ $t('折合USDT') }}</div>
          <div class="rate-info">
            <span>≈ {{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 : '0.00' }} SDT</span>
            <span>{{ $t('参考汇率') }}：{{ $store.state.userInfo.withdrawusdtrate }} {{ $t('实时变化') }}</span>
          </div>
          <div class="lasthg">{{ $t('实际到账') }}：{{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 - (chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee * 1 : $store.state.userInfo.withdrawfeeusdttrc * 1) : '0.00' }}USDT</div>
        </div>

      </div>
      <div class="usrse" v-if="activeName == 2">
        <div class="hgs" @click="$parent.goNav('/addBankCard')" v-if="usercardLis.length == 0">
          <div class="nams">{{ $t('选择银行卡') }}</div>
          <div>
            <div style="color: #4B5BF0; text-align: center">+ {{ $t('添加银行卡') }}</div>
          </div>
        </div>
        <div class="hgs" v-else @click="changShow">
          <div class="nams">{{ $t('选择银行卡') }}</div>
          <div class="cardhgs" v-if="bankId">
            <img :src="hgInfo.ico" alt="" />
            <div>{{ hgInfo.bank }} <span>{{ hgInfo.bank_owner }}</span><span>****</span>{{ hgInfo.bank_no.substr(-4) }}</div>
          </div>
          <div v-else style="color: #1e90ff; height: 30px; line-height: 30px; text-align: center">{{ $t('请选择银行卡') }}</div>

        </div>
        <div class="hgs">
          <div class="nams">{{ $t('充值打码量') }}</div>
          <div>
            <van-cell-group>
              <van-field v-model="betAmount" type="text" disabled :placeholder="$t('打码量')"> </van-field>
            </van-cell-group>
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('赠送打码量') }}</div>
          <div>
            <van-cell-group>
              <van-field v-model="gift_water" type="text" disabled :placeholder="$t('打码量')"> </van-field>
            </van-cell-group>
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('取款金额') }}</div>
          <div>
            <van-cell-group>
              <van-field v-model="amount" type="text" :placeholder="$t('请输入取款金额')">
                <template #button>
                  <div class="all-money" @click="bigMey($store.state.userInfo.balance)">{{ $t('最大金额') }}</div>
                </template>

              </van-field>
            </van-cell-group>
          </div>
        </div>

        <div class="hgs">
          <div class="nams">{{ $t('支付密码') }}</div>
          <div>
            <van-cell-group>
              <van-field v-model="password"  autocomplete="new-password"  type="password" :placeholder="$t('请输入支付密码')"> </van-field>
            </van-cell-group>
          </div>
        </div>
      </div>
      <div v-if="activeName == 2">
        <div class="submit-btn" @click="withdraw2">{{ $t('立即取款') }}</div>
        <div class="textcns">{{ $t('取款遇到问题') }}？{{ $t('联系') }} <span @click="$parent.openKefu">{{ $t('人工客服') }}</span> {{ $t('解决') }}</div>
      </div>
      <div v-if="activeName == 1">
        <div class="submit-btn" @click="withdraw1">{{ $t('立即取款') }}</div>
        <div class="textcns">{{ $t('取款遇到问题') }}？{{ $t('联系') }} <span @click="$parent.openKefu">{{ $t('人工客服') }}</span> {{ $t('解决') }}</div>
      </div>
    </div>

    <!-- 弹出层  -->
    <van-popup v-model="show" position="bottom" v-if="activeName == 2 && show" :style="{ height: '70%', background: '#f8f8f8' }" class="card">
      <div class="poptit">{{ $t('请选择银行卡') }}</div>

      <div class="lis" v-for="(item, index) in usercardLis" :key="index" @click="changApiType(item)">
        <img class="lefs" :src="item.ico" alt="" />
        <div class="cest">
          <div class="type">{{ item.bank }}</div>
          <div class="type">{{ item.bank_owner }}</div>
          <!-- <div class="type">{{ item.bank_address }}</div> -->
          <div class="num">
            <span>****</span><span>****</span><span>****</span><span>{{ item.bank_no.substr(-4) }}</span>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show" position="bottom" v-if="activeName == 1 && show" :style="{ height: '70%', background: '#f8f8f8' }" class="card">
      <div class="poptit">{{ $t('请选择USDT地址') }}</div>
      <div class="lis" v-for="(item, index) in usdssLis" :key="index" @click="changApiType(item)">
        <img class="lefs" src="/static/image/1595237922936176.png" alt="" />
        <div class="cest">
          <div class="type">{{ item.bank }}-{{ item.bank_owner }}</div>
          <div class="num">
            <span>****</span><span>****</span><span>****</span><span>{{ item.bank_no.substr(-4) }}</span>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showName" position="bottom" :style="{ height: '24%'}" >
      <div class="realName-box">
        <van-field v-model="realname" :label="$t('真实姓名')" :placeholder="$t('绑定真实姓名后不可修改')" />
        <van-button class="submit" type="info" @click="editRealname()">{{ $t('确认修改') }}</van-button>
      </div>
    </van-popup>

  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'withdrawal',
  data() {
    return {
      usercardLis: [],
      usdssLis: [],
      amount: null,
      bankId: null,
      chanmeyXi: null,
      password: null,
      activeName: 2,
      daoTime: null,
      balancelist: [],
      showLis: 3,
      show: false,
      hgInfo: {},
      betAmount: null,
      gift_water: null,

      realname: '',

      showName: false,

      gameblance: 0,  // 游戏钱包

    };
  },
  created() {
    let that = this;
    that.getBetAmount();

    that.getUsercard();
    that.getUsdssList();
    that.getbalancelist();
    that.daoTime = setInterval(() => {
      that.getbalancelistNoLoding();
    }, 3500);
    if(this.$store.state.userInfo.realname !== this.$store.state.userInfo.username) {
      this.showName = true
    }
  },
  methods: {
        getBetAmount() {
      let that = this;
      that.$apiFun
        .post('/api/getBetAmount', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.betAmount = res.data.recharge_water;
            that.gift_water = res.data.gift_water;
          }
        })
        .catch(res => {});
    },
    bigMey(val) {
      this.amount = val * 1;
    },
    changShow() {
      this.show = !this.show;
    },
    changShowLis(val) {
      this.showLis = val;
    },
    getbalancelist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            this.gameblance = 0
            balancelist.forEach(item => {
              this.gameblance+=Number(item.balance)
            })
            that.balancelist = balancelist;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            that.balancelist = balancelist;
          }
        })
        .catch(res => {});
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changApiType(e) {
      let that = this;
      that.hgInfo = e;
      console.log(e);
      if (that.qutype == 1) {
        let chanmeyXi = null;
        that.usdssLis.forEach(el => {
          if (el.id == e) {
            chanmeyXi = el.bank_owner;
            return;
          }
        });
        that.chanmeyXi = chanmeyXi;
      } else {
        that.chanmeyXi = null;
      }
      that.bankId = e.id;
      that.password = null;
      that.amount = null;
      that.show = false;
    },
    changevT(type) {
      let that = this;
      console.log(type);
      if (type == that.activeName) {
        return;
      }
      that.hgInfo = {};
      that.activeName = type;
      that.amount = null;
      this.bankId = null;
      this.chanmeyXi = null;
      this.password = null;
    },
    withdraw2() {
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;

      if (!bank) {
        that.$parent.showTost(0, that.$t('请选择您要提现到的银行卡'));
        return;
      }
      if (amount < 100) {
        that.$parent.showTost(0, that.$t('单笔取款不能低于100元'));
        return;
      }

      if (!password) {
        that.$parent.showTost(0, that.$t('请输入您的支付密码'));
        return;
      }
      if(this.$store.state.userInfo.realname === this.$store.state.userInfo.username) {
          this.withdraw()
      }else {
          this.showName = true
      }
    },
    editRealname() {
      if (this.realname.length === 0) {
        this.$parent.showTost(0, this.$t('请填写用户实名信息'));
        return;
      }
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/editRealname', { realname: this.realname }).then(res => {
        this.$parent.getUserInfoShowLoding();
        this.showName = false
        this.realname = ''
        this.$parent.showTost(1, this.$t('提交成功'));
        this.$parent.hideLoading();
      }).catch(() => {
        this.$parent.hideLoading();

      })
    },
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    async withdraw() {
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      that.$parent.showLoading();


      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, that.$t('等待后台审核'));

            that.changevT();
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    withdraw1() {
      let that = this;
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.$parent.showTost(0, that.$t('请选择USDT地址'));
        return;
      }
      if (amount < 100) {
        that.$parent.showTost(0, that.$t('单笔取款不能低于100元'));
        return;
      }

      if (!password) {
        that.$parent.showTost(0, that.$t('请输入您的支付密码'));
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, that.$t('等待后台审核'));
            that.changevT();
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },

    getUsercard() {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
        this.$parent.hideLoading();
      });
    },
    getUsdssList() {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
        this.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss">
.withdrawal {
  .van-cell-group {
    background: transparent;
  }
  .van-cell {
    background: transparent;
  }
  .van-field__button {
    display: flex;
    align-items: center;
  }
  .van-field__control {
    text-align: right;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    box-shadow: 0 0 0px 1000px transparent inset !important;
    -webkit-text-fill-color: #fff !important; /* 保持文本颜色继承 */
    transition: background-color 9999s ease-out 0s !important;
  }
}


.withdrawal .van-field__label {
  width: auto;
}
</style>
<style lang="scss" scoped>
.withdrawal {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .tabVox {
    margin: 0 .4rem;
    display: flex;
    justify-content: space-between;
    height: 1.33rem;
    align-items: center;
    background: rgba(255, 255, 255, 0.10);
    border: .03rem solid rgba(255, 255, 255, 0.10);
    border-radius: .21rem;
    .tab {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.43rem;
      font-weight: bold;
    }
    .tab.atc {
      background: linear-gradient(to bottom, #2E0B71, #7214D7);
      border-radius: .21rem;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: 0 .4rem;
    .card-info {
      background: rgba(255, 255, 255, 0.10);
      border: .03rem solid rgba(255, 255, 255, 0.10);
      border-radius: .21rem;
      margin-top: .27rem;
      padding: .27rem .27rem .53rem;
      .qibao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        .fes {
          font-size: 0.37rem;
        }
        .imgs {
          flex: 1;
          img {
            width: 0.43rem;
            margin-left: 0.16rem;
            display: flex;
            align-items: center;
          }
        }
        .btns {
          color: #bbb;
          font-size: 0.32rem;
        }
      }
      .mesg {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: .53rem;
        .line {
          width: .03rem;
          height: 0.84rem;
          background: rgba(255,255,255,0.1);
        }
        .bosgf {
          flex: 1;
          text-align: center;
          .label {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.32rem;
            margin-top: .19rem;
            img {
              width: 0.43rem;
              height: .43rem;
              margin-right: 0.16rem;
            }
          }
          .bots {
            font-size: 0.43rem;
            color: #4D5BF1;
            span {
              font-size: 0.27rem;
              margin-right: .11rem;
            }
          }
        }
      }

    }
    .gameBox {
      display: flex;
      flex-wrap: wrap;
      .lis {
        width: 25%;
        text-align: center;
        box-sizing: border-box;
        padding-top: 0.4rem;
        .name {
          font-size: 0.23rem;
          color: #383b43;
          line-height: 1;
          overflow: hidden; //超出隐藏
          text-overflow: ellipsis; //显示省略号
          white-space: nowrap; //强制不换行
        }
        .num {
          font-size: 0.23rem;
          color: #cbced8;
          margin-top: 0.2rem;
        }
        img {
          width: 0.32rem;
        }
      }
    }

    .usrse {
      box-sizing: border-box;
      padding-top: 5px;
      .hgs {
        background: rgba(255, 255, 255, 0.10);
        border: .03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .21rem;
        margin-top: .27rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 1.49rem;
        padding: 0 .27rem;
      }
      .nams {
        font-size: 0.37rem;
        vertical-align: middle;
        font-weight: bold;
      }
      .imgsa {
        position: relative;
        height: 2rem;
        padding-bottom: 0.2rem;
        .bisn {
          width: 0.8rem;
          position: absolute;
          bottom: 0.3rem;
          left: 1.4rem;
        }
        img {
          width: 2rem;
          border-radius: 50%;
        }
      }
      .money-info-box {
        background: rgba(255, 255, 255, 0.10);
        border: .03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .21rem;
        margin-top: .27rem;
        padding: 0 .27rem;
        height: 2.13rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .rate-info {
          font-size: 0.32rem;
          color: #999;
          margin-top: .16rem;
          span:first-child {
            margin-right: .61rem;
          }
        }
        .lasthg {
          font-size: 0.32rem;
          color: #999;
          margin-top: .11rem;
        }
      }
    }

    .all-money {
      height: 0.8rem;
      display: flex;
      align-items: center;
      padding: 0 .32rem;
      background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
      color: #fff;
      border-radius: .11rem;
      font-size: 0.37rem;
      font-weight: bold;
    }

    .submit-btn {
      height: 1.23rem;
      margin-top: 1.28rem;
      background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
      border-radius: .6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.43rem;
      font-weight: bold;
    }
    .textcns {
      color: #BBBBBB;
      font-size: .32rem;
      text-align: center;
      margin: .53rem 0;
      span {
        color: #4B5BF1;
      }
    }
  }
}

.card {
  .lis {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 95%;
    margin: 0 auto;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 10px 25px;
    min-height: 80px;
    border-radius: 10px;
    position: relative;
    border-radius: 0.16rem;
    background-color: #f8f9ff;
    -webkit-box-shadow: 0 0.04rem 0.2rem rgb(199 212 255 / 42%);
    box-shadow: 0 0.04rem 0.2rem rgb(199 212 255 / 42%);
    border: 0.02rem solid #fff;
    .lefs {
      width: 1.5rem;
    }
    .cest {
      flex: 1;
      margin: 0 20px;
      .type {
        font-size: 0.4rem;
        font-weight: 700;
        color: #98a8c5;
        margin-top: 6px;
      }
      .num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 6px;
        color: #98a8c5;
        span {
          font-size: 0.6rem;
        }
      }
    }
    .rigss {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 0.6rem;
    }
  }
}

.poptit {
  height: 1.4rem;
  font-size: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 22;
}

.cardhgs {
  display: flex;
  align-items: center;
  color: #1e90ff;
  font-size: 0.23rem;
  height: 1.2rem;
  img {
    width: 0.8rem;
    margin: 0 1rem;
  }
  span {
    display: inline-block;
    margin: 0 4px;
    font-size: 0.23rem;
  }
}

.realName-box {
  padding: 0.3rem 0.5rem;
  .submit {
    width: 100%;
    border-radius: .6rem;
    margin-top: .2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/withdrawal.vue